import { cookiesLimits, makeCookiesPubl, makeUserConsentVault } from '@tinkoff/statist-page-data';
import { CookieStorage } from '@tinkoff/statist-page-data/browser';
export var cookies = makeCookiesPubl(new CookieStorage(cookiesLimits), makeUserConsentVault());
//# sourceMappingURL=cookies.js.map